import React, { Component } from 'react';
import { Switch, Redirect, Route, withRouter } from 'react-router-dom';
import { PrivateRoute } from 'slide-new-toolkit';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  Products,
  Categories,
  Orders,
  User,
  Users,
  Log,
  Homepage,
  District,
} from '../';
import NotFound from '../Exception/404';
import { Global, Category, User as UserModel } from '../../models';

class Main extends Component {
  static propTypes = {
    // category: PropTypes.object,
    loadDistrict: PropTypes.func.isRequired,
    loadCategory: PropTypes.func.isRequired,
    loadEvent: PropTypes.func.isRequired,
    loadUser: PropTypes.func.isRequired,
    auth: PropTypes.object,
  }

  static defaultProps = {
    auth: {},
    // category: {},
  }

  constructor(props) {
    super(props);
    this.state = {
      isLoaded: false,
    };
  }

  async componentDidMount() {
    await Promise.all([
      this.props.loadDistrict(),
      this.props.loadCategory(),
      this.props.loadEvent(),
      this.props.loadUser(),
    ]);
    this.setState({ isLoaded: true });
  }

  // componentWillReceiveProps(nextProps) {
  //   if (!this.state.isLoaded && this.props.category.all.isLoading === true && nextProps.category.all.isLoading === false) {
  //     this.setState({ isLoaded: true });
  //   }
  // }

  render() {
    return this.state.isLoaded && (
      <Switch>
        {/* <PrivateRoute exact path="/" component={OrdersComponent} /> */}
        <PrivateRoute path="/products" component={Products} />
        <PrivateRoute path="/categories" component={Categories} />
        <PrivateRoute path="/orders" component={Orders} />
        {
          this.props.auth && this.props.auth.user && this.props.auth.user.root &&
          <PrivateRoute path="/users" component={Users} />
        }
        <PrivateRoute path="/district" component={District} />
        <PrivateRoute path="/homepage" component={Homepage} />
        <PrivateRoute path="/profile" component={User} />
        <PrivateRoute path="/log" component={Log} />
        <Redirect to={{ pathname: '/orders' }} />
        <Route component={NotFound} />
      </Switch>
    );
  }
}

const mapStateToProps = state => ({
  auth: state.auth,
});

const mapDispatchToProps = {
  loadDistrict: Global.loadDistrict,
  loadCategory: Category.all,
  loadUser: UserModel.list,
  loadEvent: Global.loadEvent,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Main));



// WEBPACK FOOTER //
// ./src/containers/Main/index.js